<template>
  <div class="signup bg-gray">
    <div class="row pt-5 pb-5">
      <div class="col-12 col-md-7 mx-auto px-0 done ">
        <b-card class="px-5 py-4 text-center">
          <h4 class="text-center"><b>{{$t("message.copmplete_payment")}}</b></h4>
          <p class="mt-5 text-center">{{$t("message.copmplete_payment_descript")}}</p>

          <router-link :to="'/mypage'">
            <b-button  class="next py-2 px-4 mt-4"> {{$t("message.start_sevice")}} </b-button>
          </router-link>
        </b-card> 
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.$store.commit('setLoading', false)
  },
}
</script>

<style scoped lang="scss">
.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}
</style>